import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Bot, Users, Cpu, GitBranch, Play } from 'lucide-react';
import { cn } from '../../../lib/utils';

const getNodeIcon = type => {
  switch (type) {
    case 'start':
      return Play;
    case 'agent':
      return Bot;
    case 'team':
      return Users;
    case 'llm':
      return Cpu;
    case 'condition':
      return GitBranch;
    default:
      return Bot;
  }
};

const getNodeColor = type => {
  switch (type) {
    case 'start':
      return 'bg-[var(--o1)] text-[var(--ink)] border-[var(--o2)]';
    case 'agent':
      return 'bg-[var(--o-tint)] text-[var(--o-deep)] border-[var(--o1)]';
    case 'team':
      return 'bg-[#ecfdf5] text-[#0f766e] border-[#a7f3d0]';
    case 'llm':
      return 'bg-[var(--card-warm)] text-[var(--ink)] border-[var(--line)]';
    case 'condition':
      return 'bg-[var(--o-tint)] text-[var(--o2)] border-[var(--o1)]';
    default:
      return 'bg-[var(--card)] text-[var(--quiet)] border-[var(--line)]';
  }
};

export const WorkflowNode = memo(({ data, selected }) => {
  const nodeType = data.type;
  const nodeLabel = data.label;

  const Icon = getNodeIcon(nodeType);
  const colorClasses = getNodeColor(nodeType);

  return (
    <div
      className={cn(
        'px-4 py-3 rounded-xl border-2 bg-[var(--card)] min-w-[180px] shadow-md transition-all',
        colorClasses,
        selected && 'ring-2 ring-[var(--o1)] ring-offset-2 ring-offset-[var(--paper)]',
      )}>
      {nodeType !== 'start' && (
        <Handle type="target" position={Position.Top} className="w-3 h-3 !bg-[var(--o2)] !border-[var(--card)]" />
      )}

      <div className="flex items-center gap-2">
        <Icon className="h-5 w-5 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm truncate">{nodeLabel}</div>
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} className="w-3 h-3 !bg-[var(--o2)] !border-[var(--card)]" />
    </div>
  );
});

WorkflowNode.displayName = 'WorkflowNode';
